import { render, staticRenderFns } from "./ApiView.vue?vue&type=template&id=28f00a5f&"
import script from "./ApiView.vue?vue&type=script&lang=js&"
export * from "./ApiView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports